import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import CmpLogoutBtn from "../../components/logout-btn.cmp";
import CmpVideoInfo from "../../components/videoInfo.cmp";
import CmpVideoList from "../../components/videoList.cmp";
import CmpVideoPlayer from "../../components/videoPlayer.cmp";
import useLogin from "../../hooks/useLogin.hk";
import { getVideos } from "../../service";
import { videoPlay } from "../../store/features/VideoSlice";
import { setPageTitle } from "../../utils/page";
import { googleAnalyticsTracker }  from "../../utils/google";
import "./videos.pg.scss";
import { timeToSeconds } from "../../utils/date";

const PgVideos = () => {
	const history = useHistory();
    const [user, , logout] = useLogin();
    const [state, setState] = useState({
		pageTitle: "",
        videos: [],
		expired: false
    });

	const dispatch = useDispatch();

	useEffect(() => {
		setPageTitle("Video");
	});
    
    useEffect(() => {
        if (!user) { history.push("/login"); }
		else {
			googleAnalyticsTracker("page", "videos", user.username);

			getVideos(user.token).then(res => {
				if (res.data.status === "OK") {
					const v = res.data.videos;

					for(let i = 0; i < res.data.videos.length; i++) {
						let video = res.data.videos[i];
						video["fromIa"] = false;
						if(video["idIa"].trim() !== "" && video["descriptionIa"].trim() !== "") {
							video["toc"] = [];
							try{
								video["toc"] = JSON.parse(video["descriptionIa"]).data.chapters;
								let html = `<h2>Indice dei Contenuti</h2>`						
								for(let i = 0; i < video["toc"].length; i++) {
									let chapter = video["toc"][i];
									let chapterIdx = i + 1;
									html += `<article>
										<header>
											<h3>Capitolo ${chapterIdx}: ${chapter.title}</h3>
											<p><small>Durata capitolo: ${video["toc"][i].sections[0].start} - ${video["toc"][i].sections[video["toc"][i].sections.length -1].end}</small></p>
										</header>
										`;
									for(let j = 0; j < video["toc"][i].sections.length; j++) {
										let section = video["toc"][i].sections[j];
										let sectionIdx = j + 1;
										html += `<section><h4><a href="/video?id=${video["idIa"]}&t=${timeToSeconds(section.start) === 0 ? 1 : timeToSeconds(section.start) }">
										${chapterIdx}.${sectionIdx} 
										${section.title} <span class="time-badge">(${section.start})</span></a></h4></section>`;
									}
									html += `</article>`
								}
								html += ``
								video["descriptionIa"] = html;
								video["fromIa"] = true;
							}catch(e) {
								video["toc"] = [];
								video["descriptionIa"] = "";
								video["fromIa"] = false;
							}
							
							let y = 0;
						}

					}

					
					setState({
						videos: v,
						pageTitle: res.data.pageTitle
					});
					googleAnalyticsTracker("page", "videos", user.username);

					if (v.length < 1) return;
					dispatch(videoPlay({video:v[0]}));
				}
				else {
					logout();
				}
			})
			.catch(err => logout());
		}
    }, [user]);

	const handleVideoLinkClick = ({ href, id, timestamp }) => {
		console.log("Video ID:", id); // "9eaa6233-8414-4c62-b552-273fa1a1a539"
		console.log("Seek Timestamp:", timestamp); // "100"

		let v = state.videos.filter(x => x.idIa == id)
		if(v.length == 1) {
			let video = v[0];
			dispatch(videoPlay({video:video, startTime: timestamp, t: new Date().getTime()}));
			let targetElement = document.querySelector(".video-player");
			if(targetElement) {
			targetElement.scrollIntoView({
				behavior: 'smooth', // 'auto' for instant jump
				block: 'start',     // 'start', 'center', 'end', or 'nearest'
				inline: 'nearest'
				});
			}
		}
			// if (timestamp) {
		// // Example: Seek current video player to 100 seconds
		// playerRef.current?.seekTo(Number(timestamp));
		// } else {
		// // Example: Navigate using React Router
		// navigate(href);
		// }
	};
    
    return (
        <div className = "pg-videos">
			<div className = "video-player">
				<div className = "container">
					<div className = "title-wrapper">
						{renderTitleDangerously(state.pageTitle)}

						{renderBtnUsers(user, history)}

						<CmpLogoutBtn/>
					</div>
					
					{
						state.videos.length?
						<div className = "row">
							<div className = "col-12">
								<CmpVideoPlayer user = {user}/>
							</div>
							<div className = "col-12">
								<CmpVideoInfo onLinkClick={handleVideoLinkClick}/>
							</div>
						</div> : null
					}
				</div>
			</div>
			<div className = "container">
				<CmpVideoList videoList = {state.videos}/>
			</div>
        </div>
    );
}

const renderTitleDangerously = (html) => {
    return <h1 className = "title mr-auto" dangerouslySetInnerHTML = {{__html: html}}/>
};

const renderBtnUsers = (user, history) =>
	user.isAdmin?
		<>
		<button className = "users-btn mr-3" onClick = {() => history.push("/users")} title = "Log utenti">
		Log utenti
		<FontAwesomeIcon icon = "users-cog" className = "ml-2"/>
		</button> 
		<button className = "xml-btn mr-3" onClick = {() => history.push("/edit")} title = "Edit xml">
		Edit xml
		<FontAwesomeIcon icon = "edit" className = "ml-2"/>
		</button> 
		</>

	:
	null;

export default PgVideos;